/**
 * What happened to a new or reset password, which is one of two quite different things.
 *
 * Where mail works the Hub emails a link and NOBODY — the administrator included — ever sees
 * a password: the person sets their own. Where it does not, the Hub generates one and that is
 * the only time it is shown.
 *
 * A union rather than `password: string | null`, because the two outcomes need different
 * words. Reading the null as "no news" is exactly what went wrong on the People page: an
 * invited account closed its dialog and said nothing at all, so an administrator had no way to
 * tell an invitation from a failure — and an emailed reset showed a panel headed "Temporary
 * password" with nothing under it.
 */
export type Handover =
  | { kind: 'password'; name: string; password: string }
  | { kind: 'invited'; name: string; email: string };

/**
 * Which of the two happened, decided by whether there is a password to show.
 *
 * THE PASSWORD IS THE DISCRIMINATOR, not the API's `invited` / `emailed` flag. It is the thing
 * that decides what can honestly be said — and the two can disagree: `POST /people/:id/
 * password-reset` reports `emailed: false` and still hands back a password when mail is
 * configured but the send itself failed. Keying on the flag would promise an email nobody got.
 */
export function outcomeOf(name: string, password: string | null, email: string): Handover {
  return password ? { kind: 'password', name, password } : { kind: 'invited', name, email };
}
